import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

// Finalizes the session: server-side this triggers LMN generation +
// payment routing (stubbed for Phase 6). Returns the redirect URL the
// merchant supplied at session creation so the client can bounce the
// shopper back into Shopify's thank-you flow.
//
// Idempotent: completing an already-complete session returns the same
// redirect URL.
export const completeHsaSession = unaryRpc({
  name: "completeHsaSession",
  input: z.object({ sessionToken: z.string().uuid() }),
  output: z.object({ completedRedirectUrl: z.string().url() }),
});
